var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class BinaryMoip {
    constructor(socket, log) {
        this.socket = socket;
        this.apiState = 'username';
        this.channels = {};
        this.firmwareVersion = '4.3.0.7';
        this.videoOutputs = {}; // RX, TX (output, input)
        this.numberVideoInputs = 16;
        this.numberVideoOutputs = 16;
        this.timeouts = new Timeouts();
        this.apiAsyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\?Firmware/i,
                callback: (match) => {
                    this.socket.send(`?Firmware=${this.firmwareVersion}`);
                },
            },
            {
                name: 'getDevices',
                regExp: /\?Devices/i,
                callback: (match) => {
                    this.socket.send(`?Devices=${this.numberVideoInputs},${this.numberVideoOutputs}`);
                },
            },
            {
                name: 'getName',
                regExp: /\?Name=(1|0)/i,
                callback: (match) => {
                    var _a;
                    const endPointType = match[1] === '1' ? 'tx' : 'rx';
                    const results = [];
                    for (const value of Object.values((_a = this.channels) !== null && _a !== void 0 ? _a : {})) {
                        if (value.endPointType === endPointType) {
                            results.push(`\?Name=${match[1]},${value.key},${value.name}`);
                        }
                    }
                    results.forEach(result => this.socket.send(result));
                },
            },
            {
                name: 'getRouting',
                regExp: /\?Receivers/i,
                callback: (match) => {
                    const result = [];
                    for (const [rx, tx] of Object.entries(this.videoOutputs)) {
                        result.push(`${tx}:${rx}`);
                    }
                    this.socket.send(`?Receivers=${result.join(',')}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /!Switch=(\d+),(\d+)/i,
                callback: (match) => {
                    this.videoOutputs[match[2]] = match[1];
                    this.socket.send('OK');
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`#Error`);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`Password: `);
                        // Delay allows emulator to ignore the empty password and respond to allow the
                        // driver to continue connecting.
                        yield this.timeouts.delay(500);
                        this.apiState = 'authenticated';
                        this.socket.send(`Successfully Logged In!`);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
        for (let i = 1; i <= this.numberVideoOutputs; i++) {
            const chanName = `rx.${i}`;
            this.channels[chanName] = {
                key: `${i}`,
                name: `RX ${i}`,
                endPointType: 'rx',
            };
            this.videoOutputs[`${i}`] = '1';
        }
        for (let i = 1; i <= this.numberVideoInputs; i++) {
            const chanName = `tx.${i}`;
            this.channels[chanName] = {
                key: `${i}`,
                name: `TX ${i}`,
                endPointType: 'tx',
            };
        }
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.send(`Please Login to Continue`);
            this.socket.sendRaw(`Username: `);
        });
    }
}
BinaryMoip.emulatorType = 'socketEmulator';
BinaryMoip.key = '-OMqdIUEKyPLVmCWigfS';
